import { render, staticRenderFns } from "./ExtendCall.vue?vue&type=template&id=0fe92d89&scoped=true&"
import script from "./ExtendCall.vue?vue&type=script&lang=js&"
export * from "./ExtendCall.vue?vue&type=script&lang=js&"
import style0 from "./ExtendCall.vue?vue&type=style&index=0&id=0fe92d89&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe92d89",
  null
  
)

export default component.exports